"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return WorkcationLogo;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function WorkcationLogo(props) {
    var svgProps = Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 189 32",
        width: "189",
        height: "32",
        fill: "none"
    }, props);
    return /*#__PURE__*/ _react.createElement("svg", _extends({}, svgProps), /*#__PURE__*/ _react.createElement("path", {
        d: "M118.495 27.973C120.816 27.973 122.829 26.742 123.847 24.895L121.195 23.379C120.721 24.349 119.703 24.942 118.472 24.942C116.648 24.942 115.298 23.592 115.298 21.722C115.298 19.827 116.648 18.477 118.472 18.477C119.679 18.477 120.698 19.093 121.171 20.064L123.8 18.524C122.829 16.701 120.816 15.469 118.495 15.469C114.896 15.469 112.243 18.193 112.243 21.721C112.243 25.25 114.896 27.973 118.495 27.973ZM134.277 15.8V17.198C133.424 16.132 132.146 15.469 130.417 15.469C127.267 15.469 124.662 18.193 124.662 21.721C124.662 25.25 127.267 27.973 130.417 27.973C132.146 27.973 133.424 27.31 134.277 26.244V27.642H137.332V15.8H134.277ZM130.985 25.06C129.114 25.06 127.717 23.71 127.717 21.721C127.717 19.732 129.114 18.382 130.985 18.382C132.88 18.382 134.277 19.732 134.277 21.722C134.277 23.71 132.88 25.06 130.985 25.06ZM146.875 18.737V15.801H144.199V12.485L141.144 13.409V15.801H139.084V18.737H141.144V23.663C141.144 26.86 142.589 28.115 146.875 27.642V24.87C145.123 24.965 144.199 24.941 144.199 23.662V18.736H146.875V18.737ZM150.545 14.38C151.586 14.38 152.439 13.527 152.439 12.51C152.439 11.49 151.586 10.615 150.545 10.615C149.526 10.615 148.674 11.491 148.674 12.509C148.679 13.0037 148.878 13.4767 149.227 13.8265C149.577 14.1763 150.05 14.375 150.545 14.38ZM149.029 27.642H152.084V15.8H149.029V27.64V27.642ZM160.516 27.973C163.997 27.973 166.792 25.25 166.792 21.721C166.792 18.193 163.997 15.469 160.516 15.469C157.035 15.469 154.264 18.193 154.264 21.721C154.264 25.25 157.035 27.973 160.516 27.973ZM160.516 24.989C158.716 24.989 157.319 23.639 157.319 21.721C157.319 19.803 158.716 18.453 160.516 18.453C162.34 18.453 163.737 19.803 163.737 21.721C163.737 23.64 162.34 24.989 160.516 24.989ZM175.524 15.47C173.938 15.47 172.706 16.061 171.996 17.127V15.801H168.941V27.641H171.996V21.248C171.996 19.188 173.109 18.311 174.601 18.311C175.974 18.311 176.945 19.14 176.945 20.751V27.641H180V20.371C180 17.221 178.034 15.469 175.524 15.469V15.47Z",
        fill: "#0D9488"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M59.267 27.642H62.985L66.087 16.7L69.213 27.64H72.931L77.573 11.064H74.139L70.966 23.354L67.485 11.064H64.69L61.233 23.354L58.059 11.064H54.626L59.267 27.641V27.642ZM83.551 27.973C87.032 27.973 89.827 25.25 89.827 21.721C89.827 18.193 87.033 15.469 83.551 15.469C80.071 15.469 77.299 18.193 77.299 21.721C77.299 25.25 80.07 27.973 83.551 27.973ZM83.551 24.989C81.751 24.989 80.354 23.639 80.354 21.721C80.354 19.803 81.752 18.453 83.551 18.453C85.375 18.453 86.772 19.803 86.772 21.721C86.772 23.639 85.375 24.989 83.552 24.989H83.551ZM95.031 17.837V15.801H91.976V27.641H95.031V21.981C95.031 19.495 97.044 18.785 98.631 18.974V15.564C97.139 15.564 95.647 16.227 95.031 17.837ZM111.334 27.642L106.432 21.65L111.192 15.8H107.545L103.472 21.01V11.064H100.417V27.642H103.472V22.266L107.782 27.642H111.334Z",
        fill: "#0D9488"
    }), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M42.342 12.4501L34.746 8.0651V28.4361H43.626V30.4101H0.21V28.4361H4.157V15.8861L0.479 16.8061L0 14.8901L20.81 9.6881H23.89C23.5505 10.4946 23.325 11.3444 23.22 12.2131L22.743 16.1351L27.839 13.1931V28.4361H32.772V8.0661L25.178 12.4501C25.3993 10.6106 26.3025 8.92106 27.709 7.7151H23.645C24.3983 6.70895 25.3958 5.91157 26.5432 5.39834C27.6905 4.88512 28.9498 4.67302 30.202 4.7821L24.685 1.5961C25.7413 1.14395 26.8885 0.944398 28.0354 1.01332C29.1824 1.08223 30.2974 1.41772 31.292 1.9931C32.2833 2.56308 33.1282 3.35601 33.76 4.3091C34.3914 3.35605 35.236 2.56311 36.227 1.9931C37.2217 1.4177 38.337 1.08222 39.4841 1.0133C40.6312 0.944386 41.7785 1.14394 42.835 1.5961L37.317 4.7821C38.5693 4.67275 39.8289 4.88472 40.9764 5.39796C42.124 5.91119 43.1217 6.70873 43.875 7.7151H39.809C41.2165 8.92054 42.1204 10.6103 42.342 12.4501ZM23.892 18.5691H17.972V28.4361H23.892V18.5691ZM13.038 20.5421C13.0439 20.805 12.9972 21.0664 12.9007 21.3111C12.8042 21.5557 12.6598 21.7785 12.4759 21.9666C12.2921 22.1546 12.0725 22.304 11.8302 22.406C11.5878 22.508 11.3275 22.5605 11.0645 22.5605C10.8015 22.5605 10.5412 22.508 10.2988 22.406C10.0565 22.304 9.83689 22.1546 9.65305 21.9666C9.46921 21.7785 9.32479 21.5557 9.22827 21.3111C9.13175 21.0664 9.08508 20.805 9.091 20.5421C9.10261 20.0264 9.31563 19.5357 9.68447 19.1751C10.0533 18.8145 10.5487 18.6125 11.0645 18.6125C11.5803 18.6125 12.0757 18.8145 12.4445 19.1751C12.8134 19.5357 13.0264 20.0264 13.038 20.5421Z",
        fill: "#0D9488"
    }));
}

//# sourceMappingURL=WorkcationLogo.js.map